module.exports = __webpack_public_path__ + "img/select-blockchain.e80a31ca.png";